<template>
  <div>
    <el-empty v-if="!codeState.items.length" :description="t('carts.emptyDiscountCode')" />
    <div class="mt-4">
      <PromotionCodeItem 
        v-for="item in codeState.items" 
        :key="item.store_prom_id" 
        :item="item"
        :code-state="codeState"
        @click="onClickPromo"
      />
      
      <v3-infinite-loading @infinite="loadData">
        <template #complete>
          <h4 class="pt-2 text-muted">{{ t("promotions.emptyCodes") }}</h4>
        </template>
        <template #spinner>
          <span>loading...</span>
        </template>
      </v3-infinite-loading>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import V3InfiniteLoading from "v3-infinite-loading"
import { breakpoint, notificationErrors } from "../../../utils"
import { _api_getAccountPromotionCodes, _api_postAccountPromotionCodes } from "../../../api/index.js";
import PromotionCodeItem from "./PromotionCodeItem.vue"

const props = defineProps({
  currency: String,
  status: String,
})
const emit = defineEmits(['update:status'])

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs)

const codeState = reactive({
  code: null,
  items: [],
  paging: {
    after: null,
    before: null,
    has_more: false,
    next: null,
    previous: null,
  },
  params: {
    status: props.status,
    limit: 10,
    starting_after: null,
    ending_before: null,
  },
  currency: props.currency,
})

const getData = async () => {
  window.fullPageLoading("show")
  try {
    codeState.params.starting_after = null
    const resp = await _api_getAccountPromotionCodes(codeState.params)
    codeState.items = resp.data.data
    codeState.paging = resp.data.paging
    
    if (codeState.paging.has_more) {
      codeState.params.starting_after = codeState.paging.after
    }
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}
const loadData = async ($state) => {
  // window.fullPageLoading("show")
  try {
    if (!codeState.paging.has_more) {
      $state.loaded()
      return
    }
    const resp = await _api_getAccountPromotionCodes(codeState.params)
    codeState.items = [...codeState.items, ...resp.data.data]
    codeState.paging = resp.data.paging

    codeState.params.starting_after = codeState.paging.after
    // console.log("has_more: ", codeState.paging.has_more)
    if (!codeState.paging.has_more) {
      $state.complete()
    } else {
      $state.loaded()
    }

  } catch (err) {
    $state.error()
    notificationErrors(err)
  } finally {
    // window.fullPageLoading("hide")
  }
}
const onClickPromo = (item) => {
  if (props.status == "past") return
  // window.location.href = '/promotions/' + item.store_prom_id
  window.open('/promotions/' + item.store_prom_id, '_blank').focus()
}

onMounted(() => {
  getData()
})

defineExpose({ getData })
</script>
